// App Check attestation is native-only (Play Integrity / App Attest)
const initialize = (): Promise<void> => Promise.resolve()

const getAppCheckToken = (): Promise<string | null> => Promise.resolve(null)
const refreshAppCheckToken = (): Promise<string | null> => Promise.resolve(null)

export default { initialize, getAppCheckToken, refreshAppCheckToken }
